export default "__VITE_ASSET__jP61pdKh__"